import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Card } from 'antd';

import ImatgeAutorrecarregable from '../commons/imatgeAutorecarregable';
import AvisInformacioAddicionalMonitoritzacioLlampsLlegenda from './avisInformacioAddicionalMonitoritzacioLlampsLlegenda';
import { obtenirDataHoraActualUTC } from '../../actions/data';

class AvisInformacioAddicionalMonitoritzacioLlamps extends Component {

    componentDidMount() {
        const { obtenirDataHoraActualUTC } = this.props;
        obtenirDataHoraActualUTC();
    }

    shouldComponentUpdate() {
        const { dataActual } = this.props;
        return dataActual !== '';
    }

    render() {
        const { dataActual } = this.props;

        return (
            <Card className='avis-informacio-addicional-monitoritzacio-card' bordered={false}>
                <ImatgeAutorrecarregable
                    alt='Imatge llamps'
                    className='avis-informacio-addicional-monitoritzacio-llamps'
                    src='https://s3-eu-west-1.amazonaws.com/static-m.meteo.cat/content/llamps/images/mapa_llamps_avui.png'
                    inici='00:00'
                    periode='00:10'
                    marge='00:02'
                    dataActual={dataActual}
                />
                <AvisInformacioAddicionalMonitoritzacioLlampsLlegenda />
            </Card>
        );
    }

}

AvisInformacioAddicionalMonitoritzacioLlamps.propTypes = {
    dataActual: PropTypes.string,
    obtenirDataHoraActualUTC: PropTypes.func.isRequired
};

const mapStateToProps = (state) => {
    return {
        dataActual: state.dataActual
    };
};

export default connect(mapStateToProps, { obtenirDataHoraActualUTC })(AvisInformacioAddicionalMonitoritzacioLlamps);



// WEBPACK FOOTER //
// ./src/components/avis/avisInformacioAddicionalMonitoritzacioLlamps.js